import React from "react";
import {Separator} from "../ui/Seperator";
import {CircleUserIcon, Power} from "lucide-react";

function DashboardHeader() {
    return (
        <header className="h-12 py-2 px-4">
            <div className="flex justify-between items-center">
                <p className="label">GeoLight</p>
                <div className="h-full justify-center flex items-center align-middle space-x-4">
                    <p className="text-white font-bold mt-2">Welcome User</p>
                    <Separator orientation="vertical" className="h-8 my-auto" />
                    <CircleUserIcon color="white" size={24} />
                    <Power color="white" />
                </div>
            </div>
        </header>
    )
}

export default DashboardHeader;